import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { Pedido } from '../../../pedido';
import { ConfigServerService, CustomHttp } from '../../../../../core';
import { PedidoIntegracaoImportFilter } from '../../pedido-integracao-import-filter';

@Injectable({
    providedIn: 'root'
})
export class PedidoIntegracaoErpImportHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApiIntegrationErp()}/pedido`;
    }

    /** Realiza a importação dos pedidos através da integração com o ERP */
    importMany(filter: PedidoIntegracaoImportFilter): Observable<Pedido[]> {
        return this.customHttp.post<Pedido[]>(`${this.pathApi}/0/import/many`, filter);
    }

    /* Realiza a importação do pedido informado através da integração com o ERP **/
    importOne(idPedido: number): Observable<Pedido> {
        return this.customHttp.get<Pedido>(`${this.pathApi}/${idPedido}/import/one`);
    }
}
